import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState } from 'react';
import { colors, spacing } from '../../../utils/styleguide';
import Icon from '../Icon';
import SimpleModal from '../modals/SimpleModal';
import Typography from '../text/Typography';
import Flag from './Flag';

const Label = styled.label`
  display: flex;
  align-items: center;
  height: 40px;
  padding-left: 20px;
  cursor: pointer;
`;

type CurrencySelectionModalProps = {
  currencies?: { code: string; name: string }[];
  selectedCurrency?: string;
  onCurrencySelect?: (currencyCode: string) => void;
  onClose?: () => void;
};

const CurrencySelectionModal = ({
  currencies,
  selectedCurrency,
  onCurrencySelect = () => {},
  onClose,
}: CurrencySelectionModalProps = {}) => {
  const [currencySearch, setCurrencySearch] = useState('');

  return (
    <SimpleModal
      open
      fullHeight
      onClose={onClose}
      padding={0}
      header={
        <div
          css={css`
            display: flex;
            position: relative;
            > input {
              font-family: Sharp-Grotesk, Helvetica, Arial, sans-serif;
              font-weight: 400;
              font-size: 13px;
              line-height: 20px;
              height: 40px;
              flex: 1;
              padding-left: 34px;
              border-style: none;
              padding-top: 4px;
              &:focus {
                outline-width: 0;
              }
            }
          `}
        >
          <Icon
            name="search"
            size={16}
            css={css`
              position: absolute;
              top: 14px;
              pointer-events: none;
            `}
          />
          <input
            placeholder="Search"
            value={currencySearch}
            onChange={(e) => setCurrencySearch(e.target.value)}
          />
        </div>
      }
      body={
        <>
          {currencies
            ?.filter(
              ({ code, name }) =>
                code.toLowerCase().includes(currencySearch.toLowerCase()) ||
                name.toLowerCase().includes(currencySearch.toLowerCase()),
            )
            .map((cur) => (
              <Label
                key={cur.code}
                css={[
                  cur.code === selectedCurrency &&
                    css`
                      background-color: ${colors.yellow};
                    `,
                ]}
              >
                <input
                  type="radio"
                  name="currency"
                  css={css`
                    display: none;
                  `}
                  checked={cur.code === selectedCurrency}
                  onChange={() => onCurrencySelect?.(cur.code)}
                />
                <Flag currencyCode={cur.code} />
                <Typography
                  useBuiltInMargins
                  tag="span"
                  variant="buttonLarge"
                  css={css`
                    display: inline-block;
                    width: 50px;
                    margin-left: ${spacing[3]}px;
                  `}
                >
                  {cur.code}
                </Typography>
                <Typography useBuiltInMargins>{cur.name}</Typography>
              </Label>
            ))}
        </>
      }
    />
  );
};

export default CurrencySelectionModal;
